import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu, MenuInfo } from 'src/app/enum/menu.enum';
import { Perfil } from 'src/app/model/perfil';
import { PerfilService } from 'src/app/service/perfil.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {

  formulario: FormGroup;
  perfis: Perfil[] = [];
  ordemColunasTabela = ['id', 'nome', 'descricao', 'ativo', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  public errorMessage: string = '';
  parametroConsulta: any;
  tipoFiltro: any;
  tipoFiltros: String[] = ['Nome'];
  permissoes: string[] = [];
  nomePermissoes: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private perfilService: PerfilService,
    private router: Router,
    private route: ActivatedRoute,


  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.getPermissoes();
    this.listarPerfisAtivos();
  }

  togglePermissao(permissao: string) {
    const control = this.formulario.get('permissoes');
    const permissoes = (control?.value ?? []) as string[];

    if (permissoes.includes(permissao)) {
      control?.setValue(permissoes.filter(p => p !== permissao));
    } else {
      control?.setValue([...permissoes, permissao]);
    }
  }


  submit() {

    const formValues = this.formulario.value;

    const perfil: Perfil = new Perfil(
      formValues.id,
      formValues.nome,
      formValues.descricao.toUpperCase(),
      formValues.ativo,
      formValues.permissoes
    );

    if (formValues.id) {
      this.perfilService.alterar(perfil).subscribe(
        response => {
          this.snackBar.open(
            'Perfil atualizado com sucesso! Faça login novamente para aplicar as alterações.',
            'OK',
            { duration: 4000 }
          );
          this.router.navigate(['perfilForm/' + response.id]);
        },
        error => {
          this.snackBar.open(error.error.message, 'ERRO', {
            duration: 2000
          });
        }
      );
    } else {
      this.perfilService.salvar(perfil).subscribe(
        response => {
          this.snackBar.open('Perfil salvo com sucesso!', 'Sucesso', {
            duration: 2000
          });
          this.router.navigate(['perfilForm/' + response.id]);
        },
        error => {
          this.snackBar.open(error.error.message, 'ERRO', {
            duration: 2000
          });
        }
      );
    }
  }


  preparaEditar(id: number) {

    this.perfilService.consultarPorId(id).subscribe((response) => {
      this.formulario.controls['id']!.setValue(id);
      this.formulario.controls['nome']!.setValue(response.nome);
      this.formulario.controls['descricao']!.setValue(response.descricao);
      this.formulario.controls['ativo']!.setValue(response.ativo);
      this.formulario.controls['permissoes']!.setValue(response.permissoes);
    });
  }

  montarFormulario() {
    this.formulario = this.formBuilder.group({
      id: [''],
      nome: ['', Validators.required],
      descricao: ['', Validators.required],
      permissoes: [[]], // <-- array
      ativo: [true],
    });
  }


  getPermissoes() {
    this.permissoes = Object.values(Menu).map((menu) => {
      this.nomePermissoes.push(MenuInfo[menu].nome);
      return menu;
    });
  }


  getPermissaoPorNome(nome: string): Menu {
    const entry = Object.entries(MenuInfo).find(
      ([, descricao]) => descricao.nome === nome
    );

    if (!entry) {
      throw new Error(`Menu não encontrado para o nome: ${nome}`);
    }

    return entry[0] as Menu;
  }

  limparFormulario() {
    this.formulario.reset();
  }

  listarPerfisAtivos() {
    this.perfilService.buscarPerfisAtivo().subscribe((response) => {
      this.perfis = response;
      this.totalElementos = response.length;
    });
  }

  paginar(event: any) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarPerfisAtivos();
  }

  consultar() {
    if (this.parametroConsulta != null) {
      this.perfilService.buscar(this.pagina, this.parametroConsulta, this.tamanho, this.tipoFiltro).subscribe((response) => {
        this.perfis = response.content; // pegar o conteudo do pag
        this.totalElementos = response.totalElements;// pegar o total de elementos
        this.pagina = response.number;// pegar o numero de paginas
      });
    } else {
      this.listarPerfisAtivos();
    }
  }
}
